import CardVisual from '@cohort/components-xps/components/cards/CardVisual';
import i18nComponentsXpsInstance from '@cohort/components-xps/lib/i18n';
import {cn} from '@cohort/shared-frontend/utils/classNames';
import {Gift} from '@phosphor-icons/react';
import {Fragment} from 'react';
import {getI18n, useTranslation} from 'react-i18next';

type RewardCardProps = {
  title: string;
  perksCounter: number;
  perksTitles: string[];
  imageFileKey: string | null;
  animationFileKey: string | null;
  hasDarkBg: boolean;
  isMobile?: boolean;
  showPerksDetails?: boolean;
};

const RewardCard: React.FC<RewardCardProps> = ({
  title,
  perksCounter,
  perksTitles,
  imageFileKey,
  animationFileKey,
  hasDarkBg,
  isMobile,
  showPerksDetails = true,
}) => {
  const {t} = useTranslation('components', {
    keyPrefix: 'cards.rewardCard',
    lng: getI18n().language,
    i18n: i18nComponentsXpsInstance,
  });

  const perkDetails = (): JSX.Element => {
    if (perksTitles.length === 0) {
      return <Fragment />;
    }

    return (
      <ul
        className={cn(
          'list-inside !list-disc space-y-1 text-sm font-normal',
          hasDarkBg ? 'text-white/60' : 'text-black/60'
        )}
      >
        {perksTitles.map(perkTitle => (
          <li key={perkTitle}>{perkTitle}</li>
        ))}
      </ul>
    );
  };

  return (
    <div className={cn('w-full space-y-4 rounded-xl p-4', hasDarkBg ? 'bg-white/8' : 'bg-black/4')}>
      <div
        className={cn(
          'flex grid ',
          isMobile
            ? '[grid-template-columns:var(--journey-detail-reward-card-visual-mobile)_1fr]'
            : '[grid-template-columns:var(--journey-detail-reward-card-visual)_1fr]'
        )}
      >
        <div className="h-fit">
          <CardVisual
            bannerFileKey={imageFileKey ?? null}
            thumbnailFileKey={null}
            videoFileKey={animationFileKey ?? null}
            visualName={title}
            trackPlayVideoClick={() => {}}
          />
        </div>
        <div className="flex flex-col gap-4 rounded-b-xl pl-4 font-semibold">
          <div
            className={cn(
              'flex justify-between',
              isMobile ? 'my-auto flex-col space-y-4' : 'items-center'
            )}
          >
            <div className="text-lg">{title}</div>
            <div className="flex gap-1 text-xs">
              <Gift size={16} className={cn(hasDarkBg ? 'text-white/60' : 'text-black/60')} />
              <div className={cn(hasDarkBg ? 'text-white/60' : 'text-black/60')}>
                {t('perksCounter', {count: perksCounter})}
              </div>
            </div>
          </div>
          {showPerksDetails && !isMobile && perkDetails()}
        </div>
      </div>
      {isMobile && showPerksDetails && perkDetails()}
    </div>
  );
};

export default RewardCard;
